export const resolveStations = response => {
  if (!response?.data?.links || !response?.data?.result) {
    return null;
  }

  // check for missing link
  const results = response.data.result.map(result => response.data.links[result.station]);

  return results;
};
